import React from "react"

import {
  Grid,
  Typography,
  Theme,
  createStyles,
  makeStyles,
} from "@material-ui/core"
import { useSelector } from "react-redux"
import { selectChannel } from "@root/store/selectors"
import Contact from "./contact"
import Channel from "./channel"
import Metadata from "./metadata"
import Analytics from "./analytics"
import { useAppDispatch } from "@root/store"
import { loadPreferenceCenters } from "@root/store/thunks"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {},
  })
)

const Settings: React.FC = () => {
  const dispatch = useAppDispatch()
  const channel = useSelector(selectChannel)
  const classes = useStyles()

  React.useEffect(() => {
    dispatch(loadPreferenceCenters())
  }, [dispatch])

  return (
    <Grid container spacing={2} className={classes.grid}>
      <Grid item xs={12}>
        <Typography variant="h3">Contact</Typography>
        <Contact />
      </Grid>

      {channel && (
        <Grid item xs={12}>
          <Typography variant="h3">Channel</Typography>
          <Channel />
        </Grid>
      )}

      <Grid item xs={12}>
        <Typography variant="h3">Metadata</Typography>
        <Metadata />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h3">Analytics</Typography>
        <Analytics />
      </Grid>
    </Grid>
  )
}

export default Settings
